import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'promise-polyfill/src/polyfill';
import 'babel-polyfill';
import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from 'src/App';
import rootStore from 'src/rootRedux/store';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from 'src/sso/config/authConfig';
import { ThemeProvider } from 'styled-components';
import { createTheme } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import AppErrorBoundary from 'src/errorHandler/AppErrorBoundary';
import './i18n';
import { SCROLL_BAR } from 'src/constants/appConstants';

const msalInstance = new PublicClientApplication(msalConfig);

const theme = {
    calendarBackgroundColor: '#140f4b',
    scrollOption: SCROLL_BAR,
};

const miTheme = createTheme({
    breakpoints: {
        // Define custom breakpoint values.
        // These will apply to Material-UI components that use responsive
        // breakpoints, such as `Grid` and `Hidden`. You can also use the
        // theme breakpoint functions `up`, `down`, and `between` to create
        // media queries for these breakpoints
        values: {
            xs: 0,
            sm: 600,
            md: 800,
            pr: 850,
            lg: 1280,
            xl: 1920,
        },
    },
});

const date = new Date();
document.cookie = `timeZoneSet=${date.getTimezoneOffset()}`;

const { store, persistor } = rootStore;
const Index = () => (
    <Provider store={store}>
        <PersistGate
            loading={<Spinner id="app-index-spinner" animation="border" variant="primary"></Spinner>}
            persistor={persistor}
        >
            <MsalProvider instance={msalInstance}>
                <MuiThemeProvider theme={miTheme}>
                    <ThemeProvider theme={theme}>
                        <AppErrorBoundary>
                            <App />
                        </AppErrorBoundary>
                    </ThemeProvider>
                </MuiThemeProvider>
            </MsalProvider>
        </PersistGate>
    </Provider>
);

ReactDOM.render(<Index />, document.getElementById('root'));
